import React, { ReactNode, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import NavBtn from "../NavBtn";
import NavMenu from "../NavMenu";
import Sidebar from "../Sidebar";
import Topbar from "../Topbar";
import CustomToast from "../CustomToast";

import { PageContainer } from "./styles";

interface LayoutProps {
  noPadding?: boolean;
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children, noPadding }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isIframe, setIsIframe] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/saf") {
      setIsIframe(true);
    } else {
      setIsIframe(false);
    }
  }, [location]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <NavMenu toggleMenu={toggleMenu} isMenuOpen={isMenuOpen} />
      <NavBtn toggleMenu={toggleMenu} isMenuOpen={isMenuOpen} />
      <Sidebar />
      <PageContainer
        noPadding={noPadding ?? false}
        isMenuOpen={isMenuOpen}
        isIframe={isIframe}
      >
        <Topbar />
        <CustomToast />
        <div className="content-area">{children}</div>
      </PageContainer>
    </>
  );
};

export default Layout;
